import { isEmpty } from '@/src/utils/generalUtils'
import { logError } from '@/src/utils/logError'

export const pushGtmEvent = (finalPayload: any = {}) => {
    try {
        if (typeof window !== 'undefined' && !isEmpty(finalPayload)) {
            if (window?.webkit?.messageHandlers?.GAInterface?.postMessage) {
                window.webkit.messageHandlers.GAInterface.postMessage({
                    event: finalPayload.event,
                    parameters: finalPayload
                })
            } else if (window?.MobileApp?.postMessage) {
                window.MobileApp.postMessage(finalPayload.event, JSON.stringify(finalPayload))
            } else if (window.dataLayer && Array.isArray(window.dataLayer)) {
                window.dataLayer.push(finalPayload)
            }
        }
    } catch (error) {
        logError('pushGtmEvent', error)
    }
}
